export default{
    ordenes:[],
    historico:[],
    isOk: false,
    error:null,
    errorMessage:'',
    csv:[],//almacena los dato para exportarlos al csv

}